<template>
  <div>
    <Alert type="warning" style="width: 712px;padding-right: 16px;font-size:12px">
      提示：以下页数按单面计算，双面将自动2倍；此方案适用于将A3和双色独立出来收费的模式，填写指引参照"阶梯收费"
    </Alert>
    <Form ref="formInline" :model="itemData" :rules="rule" :label-width="110" inline>
      <FormItem prop="name" label="方案名称:">
        <Input v-model="data.name"/>
      </FormItem>
      <FormItem prop="basics" label="基础金额:">
        <InputNumber style="width:141px" :active-change="false" :precision="2" :min="0" :step="1" v-model="data.basics"/>
      </FormItem>
      <FormItem label="结算方案描述">
        <Input style="width: 141px" v-model="data.describe"/>
      </FormItem>
      <br/>
      <FormItem label="免费A4黑白(页):">
        <InputNumber @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.blackA4Num"/>
      </FormItem>
      <FormItem label="免费A4彩色(页):">
        <InputNumber @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.colorA4Num"/>
      </FormItem>
      <FormItem label="免费A3黑白(页):">
        <InputNumber @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.blackA3Num"/>
      </FormItem>
      <FormItem label="免费A3彩色(页):">
        <InputNumber @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.colorA3Num"/>
      </FormItem>
      <FormItem label="免费双色(页):">
        <InputNumber @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.bothNum"/>
      </FormItem>
      <br/>
      <FormItem label="A4黑白:">
        <div class="type5_row">
          阶梯1: 大于或等于 <InputNumber v-model="itemData.black.a4.a.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.black.a4.a.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
        <div class="type5_row">
          阶梯2: 大于或等于 <InputNumber v-model="itemData.black.a4.b.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.black.a4.b.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
        <div class="type5_row">
          阶梯3: 大于或等于 <InputNumber v-model="itemData.black.a4.c.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.black.a4.c.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
      </FormItem>
      <FormItem label="A4彩色:">
        <div class="type5_row">
          阶梯1: 大于或等于 <InputNumber v-model="itemData.color.a4.a.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.color.a4.a.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
        <div class="type5_row">
          阶梯2: 大于或等于 <InputNumber v-model="itemData.color.a4.b.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.color.a4.b.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
        <div class="type5_row">
          阶梯3: 大于或等于 <InputNumber v-model="itemData.color.a4.c.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.color.a4.c.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
      </FormItem>
      <br/>
      <FormItem label="A3黑白:">
        <div class="type5_row">
          阶梯1: 大于或等于 <InputNumber v-model="itemData.black.a3.a.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.black.a3.a.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
        <div class="type5_row">
          阶梯2: 大于或等于 <InputNumber v-model="itemData.black.a3.b.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.black.a3.b.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
        <div class="type5_row">
          阶梯3: 大于或等于 <InputNumber v-model="itemData.black.a3.c.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.black.a3.c.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
      </FormItem>
      <FormItem label="A3彩色:">
        <div class="type5_row">
          阶梯1: 大于或等于 <InputNumber v-model="itemData.color.a3.a.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.color.a3.a.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
        <div class="type5_row">
          阶梯2: 大于或等于 <InputNumber v-model="itemData.color.a3.b.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.color.a3.b.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
        <div class="type5_row">
          阶梯3: 大于或等于 <InputNumber v-model="itemData.color.a3.c.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.color.a3.c.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
      </FormItem>
      <br/>
      <FormItem label="双色:">
        <div class="type5_row">
          阶梯1: 大于或等于 <InputNumber v-model="itemData.both.a.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.both.a.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
        <div class="type5_row">
          阶梯2: 大于或等于 <InputNumber v-model="itemData.both.b.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.both.b.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
        <div class="type5_row">
          阶梯3: 大于或等于 <InputNumber v-model="itemData.both.c.m" class="input" @on-blur="formatContent()" :active-change="false" :precision="0" :min="0" :step="1"/>
          单价(元/页): <InputNumber v-model="itemData.both.c.money" class="input" :active-change="false" :precision="2" :min="0" :step="1"/>
        </div>
      </FormItem>
      <br/>
      <FormItem>
        <Button type="success" @click="save" v-preventReClick :loading="loading">保存</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'type6',
  props: {
    data: Object
  },
  data () {
    return {
      loading: false,
      rule: {
        name: [{ validator: (rule, value, cb) => {
          if (!this.data.name) {
            cb(new Error('方案名称未填'))
          } else {
            cb()
          }
        },
        required: true,
        trigger: 'blur' }],
        basics: [{ validator: (rule, value, cb) => {
          if (this.data.basics >= 0) {
            cb()
          } else {
            cb(new Error('基础金额未填'))
          }
        },
        required: true,
        trigger: 'blur' }]
      },
      itemData: {
        blackA4Num: null,
        blackA3Num: null,
        colorA4Num: null,
        colorA3Num: null,
        bothNum: null,
        black: {
          a4: {
            a: { m: null, money: null },
            b: { m: null, money: null },
            c: { m: null, money: null }
          },
          a3: {
            a: { m: null, money: null },
            b: { m: null, money: null },
            c: { m: null, money: null }
          }
        },
        color: {
          a4: {
            a: { m: null, money: null },
            b: { m: null, money: null },
            c: { m: null, money: null }
          },
          a3: {
            a: { m: null, money: null },
            b: { m: null, money: null },
            c: { m: null, money: null }
          }
        },
        both: {
          a: { m: null, money: null },
          b: { m: null, money: null },
          c: { m: null, money: null }
        }
      }
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      if (this.data.id && this.data.type == 6) {
        this.itemData = JSON.parse(this.data.content)
      }
    },
    formatContent () {
      // if(this.itemData.blackA4Num && (this.itemData.black.a4.a.m === null || this.itemData.black.a4.a.m < this.itemData.blackA4Num)){
      //   this.itemData.black.a4.a.m = this.itemData.blackA4Num + 1
      // }
      // if(this.itemData.blackA3Num && (this.itemData.black.a3.a.m === null || this.itemData.black.a3.a.m < this.itemData.blackA3Num)){
      //   this.itemData.black.a3.a.m = this.itemData.blackA3Num + 1
      // }
      // if(this.itemData.colorA4Num && (this.itemData.color.a4.a.m === null || this.itemData.color.a4.a.m < this.itemData.colorA4Num)){
      //   this.itemData.color.a4.a.m = this.itemData.colorA4Num + 1
      // }
      // if(this.itemData.colorA3Num && (this.itemData.color.a3.a.m === null || this.itemData.color.a3.a.m < this.itemData.colorA3Num)){
      //   this.itemData.color.a3.a.m = this.itemData.colorA3Num + 1
      // }
      // if(this.itemData.bothNum && (this.itemData.both.a.m === null || this.itemData.both.a.m < this.itemData.bothNum)){
      //   this.itemData.both.a.m = this.itemData.bothNum + 1
      // }

      let types = ['black', 'color', 'both'],
        sizes = ['a4', 'a3'],
        rows = ['a', 'b', 'c']
      types.map(type => {
        rows.map((row, index) => {
          if (index !== 0) {
            if (type === 'both') {
              if (this.itemData[type][rows[index]].m <= this.itemData[type][rows[index - 1]].m) {
                this.itemData[type][rows[index]].m = null
              }
            } else {
              sizes.map(size => {
                if (this.itemData[type][size][rows[index]].m <= this.itemData[type][size][rows[index - 1]].m) {
                  this.itemData[type][size][rows[index]].m = null
                }
              })
            }
          }
        })
      })
    },
    save () {
      this.$refs.formInline.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.data.agent_id = this.user.id
          this.data.content = JSON.stringify(this.itemData)
          this.data.type = '6'
          this.SaveMeterCharge(this.data).then(res => {
            if (res) {
              this.data.id = res
              this.$Message.success('保存成功')
            }
            this.loading = false
          })
        }
      })
    },
    ...mapActions(['SaveMeterCharge'])
  },
  computed: mapGetters({
    user: 'agent'
  })
}
</script>

<style lang="less" scoped>
  @import '../index.less';
</style>
